module.exports = __webpack_public_path__ + "trunking.svg?ad2a3626655c51138337622904c0fe0c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/patterns/trunking.svg
// module id = 100
// module chunks = 0